import { runtimeEnv } from "../config/runtimeEnv";

class AppConsts {
  static host = runtimeEnv.apiUrl;
  static drawingEditorUrl = "/drawing_editor/web/index.html";
  static yMapsKey = runtimeEnv.yMapsKey;
  static yMapsSearchKey = "45181517-f63c-4608-9a02-4254d5ff2693";
  static hostAdmin = "super_admin";
}

export default AppConsts;
